var map = {
	"./en/Big-Data-EN.jpg": 662,
	"./en/Business-Intelligence-EN.jpg": 663,
	"./en/Cloud-EN.jpg": 664,
	"./en/Consultoria-Informatica-EN.jpg": 665,
	"./en/Data-Science-EN.jpg": 666,
	"./en/Desenvolvimento-Mobile-EN.jpg": 667,
	"./en/Desenvolvimento-Web-EN.jpg": 668,
	"./en/Desenvolvimento-de-Software-EN.jpg": 669,
	"./en/Design-UX-UI-EN.jpg": 670,
	"./en/FAQs-EN.jpg": 671,
	"./en/Homepage-EN.jpg": 672,
	"./en/Machine-Learning-EN.jpg": 673,
	"./en/Oportunidades-de-Emprego-EN.jpg": 674,
	"./en/Porque-NearshorIT-EN.jpg": 675,
	"./en/Porque-Portugal-EN.jpg": 676,
	"./en/Testes-Software-EN.jpg": 677,
	"./pt/Big-Data-PT.jpg": 678,
	"./pt/Business-Intelligence-PT.jpg": 679,
	"./pt/Cloud-PT.jpg": 680,
	"./pt/Consultoria-Informatica-PT.jpg": 681,
	"./pt/Data-Science-PT.jpg": 682,
	"./pt/Desenvolvimento-Mobile-PT.jpg": 683,
	"./pt/Desenvolvimento-Web-PT.jpg": 684,
	"./pt/Desenvolvimento-de-Software-PT.jpg": 685,
	"./pt/Design-UX-UI-PT.jpg": 686,
	"./pt/FAQs-PT.jpg": 687,
	"./pt/Homepage-PT.jpg": 688,
	"./pt/Machine-Learning-PT.jpg": 689,
	"./pt/Oportunidades-de-Emprego-PT.jpg": 690,
	"./pt/Porque-NearshorIT-PT.jpg": 691,
	"./pt/Porque-Portugal-PT.jpg": 692,
	"./pt/Testes-Software-PT.jpg": 693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 661;